<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title nowrap">
            Lista grupos
            <!-- <i class="fas fa-boxes"></i>
            <i class="fas fa-th m-l-10"></i> -->
            <button style="padding: 3px 8px;" (click)="setView('grid')"
              [ngClass]="{'btn-primary': viewMode === 'grid', 'btn-outline-primary': viewMode !== 'grid'}"
              class="btn btn-sm f-s-11">
              <i class="fas fa-boxes"></i>
            </button>
            <button style="padding: 3px 8px;" (click)="setView('list')"
              [ngClass]="{'btn-secondary': viewMode === 'list', 'btn-outline-secondary': viewMode !== 'list'}"
              class="btn btn-sm f-s-11 m-l-10">
              <i class="fas fa-th"></i>
            </button>
          </h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/salidas/grupos/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear grupo </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card m-b-15">
      <div class="card-body p-t-10 p-b-10 p-l-10 p-r-10">
        <div class="row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-12 content__subhead__boxBtns">
            <button type="button" class="btn btn-light btn-sm" uib-tooltip="Actualizar" (click)="refresh()"><i
                class="fas fa-undo"></i></button>
            <div class="content__subhead__inputGrid">
              <div class="input-group">
                <span class="input-group-prepend">
                  <span class="input-group-text content__subhead__inputGrid__title">
                    <i class="far fa-calendar-alt"></i>
                  </span>
                </span>
                <input type="text" id="date_range" [(ngModel)]="date_range"
                  class="form-control text-center content__subhead__inputGrid__input">
                <span class="input-group-append">
                  <span class="input-group-text" style="padding: 2px 10px">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="pin_date" [(ngModel)]="pin_date"
                        (change)="changePinDate()">
                      <label class="custom-control-label p-t-4 f-s-10" for="pin_date">Fijar fecha</label>
                    </div>
                  </span>
                </span>
              </div>
            </div>
            <div class="content__subhead__inputGrid">
              <ng-container *ngIf="tourSelected != null">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm" disabled value="{{tourSelected.description}}">
                  <div class="input-group-append bg-custom b-0 removeClient">
                    <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                      uib-tooltip="Quitar" (click)="removeTour()">
                      <i class="fas fa-backspace w-100 f-s-12"></i>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="tourSelected == null">
                <component-search-tour [classSize]="'search-small'" (selectedTourEvent)="selectedTourSearch($event)"
                  class="w-100"></component-search-tour>
              </ng-container>
            </div>
            <button type="button" class="btn btn-light btn-sm" data-toggle="modal" data-target="#panelModal">
              <i class="fas fa-list"></i> Panel
            </button>
            <button type="button" class="btn btn-light btn-sm" data-toggle="modal" data-target="#openExtendsGroupGuideProjection" (click)="scheduleProjection()">
              <i class="fas fa-chart-bar"></i> Hist.Guia
            </button>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6 col-12">
            <component-search (searchEvent)="search($event)"></component-search>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-12">
    <ng-container *ngIf="viewMode === 'grid'">
      <div class="row" *ngIf="items_custom.length > 0">
        <div class="col-12" *ngFor="let group of items_custom">
          <p class="form__group__title" style="color: #690465;"> <i
              class="fas fa-info-circle m-r-5"></i>{{group.tour_description}} <span class="m-l-5 f-s-11">
              ({{group.items.length}} grupos)</span>
            <a href="/{{branchofficeSlug}}/api/groups/list/export/{{group.date_departure}}/{{group.tour_id}}"
              class="btn btn-small btn-default f-s-15" target="_blank" style="padding: 1px 5px;"><i
                class="far fa-file-pdf text-danger"></i> </a>
          </p>
          <div class="row">
            <div class="col-lg-3" *ngFor="let item of group.items ; let i = index">
              <div class="card group__item"
                [ngClass]="{'border-schedule-private': item.typevehicle_tour == vehicle_private }">
                <div class="card-header group__item__header">
                  <div class="flex p-0">
                    <div class="flex-60 group__item__header__code">
                      {{item.code}}
                      <a href="/{{branchofficeSlug}}/api/groups/detail/export/{{item.date_departure}}/{{item.id}}"
                        class="btn btn-small btn-default f-s-15" target="_blank" style="padding: 1px 5px;"><i
                          class="far fa-file-pdf text-primary"></i> </a>
                    </div>
                    <div class="flex-40 text-right">
                      <span class="badge badge-light f-s-11">{{item.date_departure | date: 'mediumDate'}}</span>
                    </div>
                  </div>
                </div>
                <div class="card-body group__item__body">
                  <p class="group__item__body__tour">
                    {{item.tour_data.description}}
                  </p>
                  <p class="group__item__body__item m-b-5 text-right">
                    <ng-container *ngIf="item.workinggroup_id != null">
                      <span class="badge badge-dark float-left f-s-9">G.Trabajo
                        {{item.workinggroup_data.description}}</span>
                    </ng-container>
                    <span *ngIf="item.deleted_at == null"
                      class="badge f-s-12 badge-{{item.status_group.class}}">{{item.status_group.message}}</span>
                  </p>
                  <p class="group__item__body__item">
                    <i class="fas fa-bus-alt m-r-5 "></i>{{item.transport_data.owner}}
                  </p>
                  <div class="group__item__body__item__detail">
                    {{item.transport_data.vehicle_type}} | {{item.transport_data.cellphone}}
                  </div>
                  <p class="group__item__body__item">
                    <i class="fas fa-user-tie m-r-5 "></i>{{item.guide_data.fullname}}
                  </p>
                  <div class="group__item__body__item__detail">
                    {{item.guide_data.cellphone}}
                  </div>
                  <p class="group__item__body__item bold">
                    <i class="fas fa-users m-r-5 "></i>{{item.capacity_selected}} pasajeros
                    <ng-container *ngIf="item.typevehicle_tour == vehicle_private">
                      <span class="m-l-10">
                        <span class="badge badge-orange badge-schedule-private f-s-10"><i
                            class="fas fa-bolt m-r-5"></i>Servicio Privado</span>
                      </span>
                    </ng-container>
                  </p>
                </div>
                <div class="card-footer group__item__footer">
                  <button class="btn btn-sm btn-danger" *ngIf="item.is_confirmed == false" (click)="delete(item, i)"><i
                      class="fas fa-trash-alt m-r-2"></i>Borrar</button>
                  <button class="btn btn-sm btn-info" (click)="detail(item.id)"><i
                      class="far fa-eye m-r-2"></i>Detalle</button>
                  <button class="btn btn-sm btn-primary" *ngIf="item.is_confirmed == false" (click)="edit(item.id)"><i
                      class="fas fa-pen-alt m-r-2"></i>Editar</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </ng-container>


    <ng-container *ngIf="viewMode === 'list'">
      <div class="row" *ngIf="items.length > 0">
        <div class="col-lg-3" *ngFor="let item of items ; let i = index">
          <div class="card group__item">
            <div class="card-header group__item__header">
              <div class="flex p-0">
                <div class="flex-60 group__item__header__code">
                  {{item.code}}
                </div>
                <div class="flex-40 text-right">
                  <span class="badge badge-light f-s-11">{{item.date_departure}}</span>
                </div>
              </div>
            </div>
            <div class="card-body group__item__body">
              <p class="group__item__body__tour">
                {{item.tour_data.description}}
              </p>
              <p class="group__item__body__item m-b-5 text-right">
                <ng-container *ngIf="item.workinggroup_id != null">
                  <span class="badge badge-dark float-left f-s-9">G.Trabajo
                    {{item.workinggroup_data.description}}</span>
                </ng-container>
                <span *ngIf="item.deleted_at == null"
                  class="badge f-s-12 badge-{{item.status_group.class}}">{{item.status_group.message}}</span>
              </p>
              <p class="group__item__body__item">
                <i class="fas fa-bus-alt m-r-5 "></i>{{item.transport_data.owner}}
              </p>
              <div class="group__item__body__item__detail">
                {{item.transport_data.vehicle_type}} | {{item.transport_data.cellphone}}
              </div>
              <p class="group__item__body__item">
                <i class="fas fa-user-tie m-r-5 "></i>{{item.guide_data.fullname}}
              </p>
              <div class="group__item__body__item__detail">
                {{item.guide_data.cellphone}}
              </div>
              <p class="group__item__body__item bold">
                <i class="fas fa-users m-r-5 "></i>{{item.capacity_selected}} pasajeros
              </p>
            </div>
            <div class="card-footer group__item__footer">
              <button class="btn btn-sm btn-danger" *ngIf="item.is_confirmed == false" (click)="delete(item, i)"><i
                  class="fas fa-trash-alt m-r-2"></i>Borrar</button>
              <button class="btn btn-sm btn-info" (click)="detail(item.id)"><i
                  class="far fa-eye m-r-2"></i>Detalle</button>
              <button class="btn btn-sm btn-primary" *ngIf="item.is_confirmed == false" (click)="edit(item.id)"><i
                  class="fas fa-pen-alt m-r-2"></i>Editar</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="col-12" *ngIf="items.length == 0">
      <p class="text-center m-t-20">No se encontraron grupos para esta fecha.</p>
    </div>

    <!-- sample modal content -->
    <div id="panelModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mt-0">Panel de Grupos | <span class="bold">Fecha : {{date_range | date: 'mediumDate'}}</span> </h5>
            <button class="btn btn-sm btn-outline-info f-s-11 m-l-20" (click)="printerPanel()" ><i class="fas fa-print"></i> Descarga</button>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="generated-data">
            <ng-container *ngIf="items_custom.length > 0">
              <ng-container *ngFor="let group of items_custom">
                <p class="bold m-b-5" style="color: #690465;"><i
                  class="fas fa-info-circle m-r-5"></i>{{group.tour_description}}<span class="m-l-5 f-s-11">({{group.items.length}}
                    grupos)</span></p>
                <div class="table-responsive m-b-10">
                  <table class="table table-sm">
                    <thead class="thead-default">
                      <tr>
                        <th>Movilidad</th>
                        <th>Guia</th>
                        <th class="text-center">N° Pasajeros</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let item of group.items ; let i = index">
                        <tr>
                          <td>{{item.transport_data.owner}}</td>
                          <td>{{item.guide_data.fullname}}</td>
                          <td class="text-center">{{item.capacity_selected}} pax</td>
                        </tr>
                      </ng-container>
                      
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-group-guide-projection></app-group-guide-projection>